import SalePoint from '@/views/SalePoint/SalePoint'

export default [
    {
        path: '/',
        name: '',
        component: SalePoint,
    },
]
